import React, { useContext } from "react";
import cx from "classnames";
import s from "./LoginScreen.scss";
import { connect } from "react-redux";
import * as sessionActions from "../modules/session";
import LoginForm from "Components/LoginForm";
import { getCookie } from "@/config";
import Logo from "Components/logo/Logo";
import OtpModal from "Components/otpModal/otpModal";
import withFormState from "Components/withFormState";
import ResetPwdModal from "Components/resetPwdModal/resetPwdModal";
import FirstLoginModal from "Components/firstLoginModal/FirstLoginModal";
import { Helmet } from "react-helmet";
import { Icon, loginIllustration, vianovaMail, loginXmas, vianovaLogo, poweredByQboxmail } from "Icons/index";
import i18n, { t } from "i18next";
import sessionStore from "@/stores/session";
import { view } from "@risingstack/react-easy-state";
import { SwrContext } from "ReactContext";
import { isVianovaHost } from "Utils/vianova";
import { MediaQueriesContext } from "../App";

const initialFormData = {
  email_address: "",
  password: "",
};

// show cookies only on *.qboxmail.com for whitelabel reasons
let u = new URL(window.location.href);
const SHOW_POLICIES = u.hostname.match(/qboxmail.com/) ? true : false;

const FooterLinks = ({ isVianova }) => {
  const language = i18n.language;
  const cookieLink =
    language === "it" ? "https://www.qboxmail.it/cookie-policy/" : "https://www.qboxmail.com/cookie-policy/";
  const policyLink =
    language === "it"
      ? "https://www.qboxmail.it/download/informativa-utenti-servizi.pdf"
      : "https://www.qboxmail.com/download/policy-services-users.pdf";

  return (
    <div className={cx("flex justify-center w-full gap-1 py-4 text-xs", { "!font-roboto": isVianova })}>
      <div>
        <a className="text-[--accent-d30] underline" href={cookieLink} target="_blank" rel="noreferrer">
          {t("login.footer.cookiePolicy")}
        </a>
      </div>
      <div>-</div>
      <div>
        <a className="text-[--accent-d30] underline" href={policyLink} target="_blank" rel="noreferrer">
          {t("login.footer.privacyPolicy")}
        </a>
      </div>
    </div>
  );
};

class LoginScreen extends React.Component {
  constructor(props) {
    super(props);

    this.loadCustomization();

    this.state = {
      resetPasswordOpened: false,
      otpVerificationOpened: false,
      firstLoginModalOpened: false,
      remember_device: false,
    };
  }

  componentDidMount() {
    // See https://swr.vercel.app/docs/advanced/cache#modify-the-cache-data
    this.context.swrMutate(
      //eslint-disable-next-line
      (key) => true, // which cache keys are updated
      undefined, // update cache data to `undefined`
      { revalidate: false } // do not revalidate
    );
  }

  loadCustomization = () => {
    if (!this.props.loggedUser) {
      let logo = window.localStorage.getItem("qb_customization_logo");
      if (logo === "null" || logo === "undefined") {
        window.localStorage.removeItem("qb_customization_logo");
        logo = null;
      }

      let company = window.localStorage.getItem("qb_customization_company");
      if (company === "null" || company === "undefined") {
        window.localStorage.removeItem("qb_customization_company");
        company = null;
      }

      let supportLink = window.localStorage.getItem("qb_customization_help_desk_url");
      if (supportLink === "null" || supportLink === "undefined") {
        window.localStorage.removeItem("qb_customization_help_desk_url");
        supportLink = null;
      }

      sessionStore.applyCustomization(
        {
          logo: logo,
          company: company,
          help_desk_url: supportLink,
        },
        false
      );
    }
  };

  resetPassword = (data) => {
    this.props.resetPassword(data);
  };

  showResetPasswordModal = () => {
    this.setState({ resetPasswordOpened: true });
  };

  showOtpVerificationModal = () => {
    this.setState({ otpVerificationOpened: true });
  };

  showFirstLoginModal = (emailAddress, pwd) => {
    this.setState({ firstLoginModalOpened: true, emailAddress, pwd });
  };

  closeFirstLoginModal = () => {
    this.setState({ firstLoginModalOpened: false });
  };

  closeOtpVerificationModal = () => {
    this.setState({ otpVerificationOpened: false });
  };

  closeResetPasswordModal = () => {
    this.setState({ resetPasswordOpened: false });
  };

  setRememberDeviceValue = (val) => {
    this.setState({ remember_device: val });
  };

  showXmasIllustration = () => {
    let today = new Date();
    let isDecember = today.getMonth() === 11;
    let isJanuary = today.getMonth() === 0;
    let day = today.getDate();

    if (isDecember && day >= 8) {
      return true;
    } else if (isJanuary && day <= 6) {
      return true;
    }
    return false;
  };

  QboxmailLogin = ({ setSession, setFormErrors, unsetFormLoading }) => {
    return (
      <>
        <Helmet defer={false}>
          <meta
            name="description"
            content="Panel Login. A complete and professional control panel to manage, Domains and Emails Accounts"
          ></meta>
          <meta name="application-name" content="Panel"></meta>
          <meta name="keywords" content="Panel, Email, Hosting, Cloud, Professional"></meta>
          <meta name="content-language" content={this.props.language}></meta>
          <title>{sessionStore.generatePageTitle()}</title>
        </Helmet>

        <div className="flex flex-col items-center justify-center w-full min-h-[100vh] h-max bg-[--bg] overflow-y-auto">
          <div className="flex items-start justify-center flex-grow gap-10 pt-20 sm:pt-[20vh] w-full">
            <div className="hidden md:block ">
              <Icon svg={this.showXmasIllustration() ? loginXmas : loginIllustration} width="23rem" height="23rem" />
            </div>
            <div className="w-full px-4 sm:px-0 sm:w-[23rem] flex flex-col items-center">
              <Logo className="h-10 mb-8 [&>img]:max-w-[240px] [&>img]:max-h-10" />

              <LoginForm
                setSession={setSession}
                unsetFormLoading={unsetFormLoading}
                setFormErrors={setFormErrors}
                showOtpVerificationModal={this.showOtpVerificationModal}
                showFirstLoginModal={this.showFirstLoginModal}
                setRememberDeviceValue={this.setRememberDeviceValue}
              />
              <div
                className="text-sm underline text-qb-blue cursor-pointer hover:text-[--accent-d30]"
                onClick={this.showResetPasswordModal}
              >
                {t("button.forgottenPassword")}
              </div>
            </div>
          </div>

          <ResetPwdModal
            opened={this.state.resetPasswordOpened}
            handleClose={this.closeResetPasswordModal}
            handleResetPassword={this.resetPassword}
          />

          <OtpModal
            opened={this.state.otpVerificationOpened}
            handleClose={this.closeOtpVerificationModal}
            userCode={getCookie("user_code")}
            setSession={setSession}
            onCancel={this.closeOtpVerificationModal}
            remember_device={this.state.remember_device}
          />

          <FirstLoginModal
            email_address={this.state.emailAddress}
            oldPassword={this.state.pwd}
            opened={this.state.firstLoginModalOpened}
            handleClose={this.closeFirstLoginModal}
            setSession={setSession}
          />

          {SHOW_POLICIES && <FooterLinks />}
        </div>
      </>
    );
  };

  VianovaLogin = ({ setSession, setFormErrors, unsetFormLoading }) => {
    const { isMediaMobile, isMediaLG } = useContext(MediaQueriesContext);

    return (
      <>
        <Helmet defer={false}>
          <meta
            name="description"
            content="Panel Login. A complete and professional control panel to manage, Domains and Emails Accounts"
          ></meta>
          <meta name="application-name" content="Panel"></meta>
          <meta name="keywords" content="Panel, Email, Hosting, Cloud, Professional"></meta>
          <meta name="content-language" content={this.props.language}></meta>
          <title>{sessionStore.generatePageTitle()}</title>
        </Helmet>
        <div className="flex flex-col items-center justify-center w-full min-h-[100vh] h-max bg-[--white] overflow-y-auto">
          {isMediaMobile ? (
            <Icon
              className="self-start px-4 pt-[17px] md:pt-6 md:self-start"
              width="131.25px"
              height="26px"
              svg={vianovaLogo}
            />
          ) : (
            <Icon
              className="self-start px-[22px] pt-[17px] md:pt-6 md:self-start lg:px-[30px] lg:pt-[18px] lg:pb-6"
              width="auto"
              height="26px"
              svg={vianovaLogo}
            />
          )}
          <div className={cx(s.verticalGap, "flex items-start justify-center flex-grow w-full gap-[4rem]")}>
            <div className="hidden md:flex md:items-center">
              <Icon svg={this.showXmasIllustration() ? loginXmas : loginIllustration} width="22rem" height="22rem" />
            </div>
            <div className="w-full self-stretch px-4 sm:px-0 sm:w-[22rem] lg:w-[24rem] flex flex-col items-center !font-roboto pt-11 md:pt-0">
              <Icon
                className="mb-6 lg:mb-[30px]"
                svg={vianovaMail}
                width={isMediaLG ? "219px" : "108px"}
                height={isMediaLG ? "45px" : "28px"}
              />
              <div className="flex flex-col gap-0 mb-4 lg:mb-10 text-lg font-light leading-5 text-center font-roboto lg:text-3xl lg:leading-[2.625rem]">
                <div className="font-normal">{t("login.screen.title")}</div>
                <div className="">{t("login.screen.desc")}</div>
              </div>

              <div className="w-full md:w-[24rem]">
                <LoginForm
                  className=""
                  setSession={setSession}
                  unsetFormLoading={unsetFormLoading}
                  setFormErrors={setFormErrors}
                  showOtpVerificationModal={this.showOtpVerificationModal}
                  showFirstLoginModal={this.showFirstLoginModal}
                  setRememberDeviceValue={this.setRememberDeviceValue}
                  buttonSubmitColor="accentv"
                  isVianova
                />
              </div>

              <div
                className="text-base !leading-5  md:text-sm font-semibold underline text-qb-blue cursor-pointer hover:text-[--accent-d30] mt-4 "
                onClick={this.showResetPasswordModal}
              >
                {t("button.forgottenPassword")}
              </div>
              <Icon className="mt-8" svg={poweredByQboxmail} width="180px" height="auto" />
            </div>
          </div>

          <ResetPwdModal
            opened={this.state.resetPasswordOpened}
            handleClose={this.closeResetPasswordModal}
            handleResetPassword={this.resetPassword}
          />

          <OtpModal
            opened={this.state.otpVerificationOpened}
            handleClose={this.closeOtpVerificationModal}
            userCode={getCookie("user_code")}
            setSession={setSession}
            onCancel={this.closeOtpVerificationModal}
            remember_device={this.state.remember_device}
          />

          <FirstLoginModal
            email_address={this.state.emailAddress}
            oldPassword={this.state.pwd}
            opened={this.state.firstLoginModalOpened}
            handleClose={this.closeFirstLoginModal}
            setSession={setSession}
          />

          <FooterLinks isVianova />
        </div>
      </>
    );
  };

  render() {
    const { setSession, setFormErrors, unsetFormLoading } = this.props;

    if (isVianovaHost) {
      return (
        <this.VianovaLogin setSession={setSession} setFormErrors={setFormErrors} unsetFormLoading={unsetFormLoading} />
      );
    }

    return (
      <this.QboxmailLogin setSession={setSession} setFormErrors={setFormErrors} unsetFormLoading={unsetFormLoading} />
    );
  }
}

LoginScreen.contextType = SwrContext;

const mapStateToProps = (state) => ({
  loggedUser: state.session.user,
  otp: state.session.otp,
});

const mapDispatchToProps = (dispatch) => ({
  verify: () => dispatch(sessionActions.verify()),
  setSession: (user) => dispatch(sessionActions.setSession(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(view(LoginScreen), initialFormData));
